import React from 'react';

import {DEFAULT_PAGE_SIZES} from 'src/hooks/common-data-service/cached-table';

import {FlatButton} from '@pb/kit-component-button';
import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {Group} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';

import {provisioningPagination, provisioningPaginationControls} from './provisioning-history.module.styl';

import type {ProvisioningPageSize} from './use-provisioning-history';

type Props = {
    pageSize: ProvisioningPageSize,
    hasRows: boolean,
    hasNextPage: boolean,
    hasPreviousPage: boolean,
    isLoading: boolean,
    nextPage: () => void,
    previousPage: () => void,
    setPageSize: (size: ProvisioningPageSize) => void,
    standalone?: boolean,
};

export const ProvisioningPagination = ({
    pageSize, hasRows, hasNextPage, hasPreviousPage, isLoading, nextPage, previousPage, setPageSize, standalone,
}: Props) => (
    <div className={standalone ? provisioningPagination : undefined}>
        <div aria-label="Pagination" className={provisioningPaginationControls}>
            <div style={{width: 90}}>
                <ComboBox
                    aria-label="Rows per page"
                    value={pageSize}
                    onChange={setPageSize}
                    disabled={isLoading || !hasRows}
                    width={50}>
                    {DEFAULT_PAGE_SIZES.map(size => <ComboboxItem key={size} value={size} caption={String(size)}/>)}
                </ComboBox>
            </div>
            <Group direction="h" gap="s">
                <FlatButton
                    aria-label="Go to previous page"
                    startIcon={<Icon type={Icons.ANGLE_LEFT}/>}
                    disabled={isLoading || !hasPreviousPage}
                    onClick={previousPage}>
                    Prev
                </FlatButton>
                <FlatButton
                    aria-label="Go to next page"
                    endIcon={<Icon type={Icons.ANGLE_RIGHT}/>}
                    disabled={isLoading || !hasNextPage}
                    onClick={nextPage}>
                    Next
                </FlatButton>
            </Group>
        </div>
    </div>
);
